<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">筛选条件：</span>
					<el-select v-model="search_condition" class="b_inp" placeholder="请选择">
						<el-option :value="0" label="全部"></el-option>
						<el-option v-for="v in conditions" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="search_name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">账号：</span>
					<el-input v-model="search_account" class="b_inp" placeholder="账号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">所属机构：</span>
					<el-input v-model="search_agency_name" class="b_inp" placeholder="所属机构"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">角色：</span>
					<el-select v-model="search_role" class="b_inp" placeholder="请选择">
						<el-option :value="0" label="全部"></el-option>
						<el-option v-for="v in roles" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="list"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="account"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="conditionName"
						label="所属条件"
					>
					</el-table-column>
					<el-table-column
						prop="agencyName"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="masterLabel"
						label="默认客服"
					>
					</el-table-column>
					<el-table-column
						prop="roleName"
						label="角色"
					>
					</el-table-column>
					<el-table-column
						prop="createrName"
						label="创建者"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
				
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="page"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增弹出框 -->
		<add 
			v-model="add_display"
			:conditions="conditions"
			:roles="roles"
			@complete="findCustomer"
		></add>
		<!-- 新增弹出框 end -->
		
		<!-- 修改弹出框 -->
		<update
			v-model="update_display"
			:conditions="conditions"
			:roles="roles"
			:obj="update_obj"
			@complete="findCustomer"
		></update>
		<!-- 修改弹出框 end -->
		
		<!-- 删除筛选条件弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除筛选条件弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../../api/index.js'
	import Add from './components/add.vue'
	import Update from './components/update.vue'
	import BaseMethods from '../../../../../../assets/js/base.js'
	
	export default {
		mounted() {
			this.findCondition();
		},
		data() {
			return {
				loading: false,
				conditions: [],
				roles: [],
				page: 1,
				total: 0,
				list: [],
				
				search_condition: 0,
				search_name: '',
				search_account: '',
				search_agency_name: '',
				search_role: 0,
				
				add_display: false,
				
				update_display: false,
				update_obj: {},
				
				delete_display: false,
				delete_id: '',
				delete_conditionUserId: ''
			}
		},
		methods: {
			/************************ @Events *******************************/
			// 点击查询
			handleSearchClick() {
				this.page = 1;
				this.findCustomer();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.page != page) {
					this.page = page;
					this.findCustomer();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_obj = data;
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				this.delete_id = obj.id;
				this.delete_conditionUserId = obj.conditionUserId;
				this.delete_display = true;
			},
			// 点击删除弹出确定按钮
			handleDeletePopupConfirmClick() {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id,
					conditionUserId: that.delete_conditionUserId
				};
				Api.deleteCustomer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.page = 1;
						that.findCustomer();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/************************ @Function *******************************/
			// 获取所有查询条件
			findCondition() {
				const that = this;
				that.loading = true;
				var requestData = {
					code: null,
					conditionId: null,
					id: null,
					limit: null,
					pageNum: null,
					roleId: null,
					type: 0
				};
				Api.findCustomerCondition(requestData).then((res) => {
					if (res.data.success) {
						res.data.data.forEach(v => {
							that.conditions.push({
								id: v.id,
								name: v.explains
							});
						});
						that.findRole();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取客服对应角色
			findRole() {
				const that = this;
				Api.findCustomerRole({}).then((res) => {
					if (res.data.success) {
						res.data.data.forEach(v => {
							that.roles.push({
								id: v.id,
								name: v.roleName
							});
						});
						that.findCustomer();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取对应的客服
			findCustomer() {
				const that = this;
				that.loading = true;
				var requestData = {
					code: that.search_account,
					conditionId: that.search_condition ? that.search_condition : null,
					enterpriseName: that.search_agency_name,
					id: null,
					limit: 10,
					name: that.search_name,
					pageNum: that.page,
					roleId: that.search_role ? that.search_role : null,
					type: 1
				};
				Api.findCustomer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.list = [];
						res.data.data.data.forEach(v => {
							that.list.push({
								id: v.id,
								conditionUserId: v.conditionUserId || '',
								account: v.code || '',
								name: v.name || '',
								agencyName: v.uenterpriseName || '',
								conditionId: v.conditionId || '',
								conditionName: v.conditionName || '',
								isMaster: v.isMaster || '',
								masterLabel: v.isMaster == 1 ? '是' : '否',
								roleId: v.roleId || '',
								roleName: v.roleName || '',
								createrId: v.creater || '',
								createrName: v.createrName || '',
								creatDate: BaseMethods.formatTime(v.createTime)
							});
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style scoped>
</style>
